import React from "react";
import {
  FaCalendarAlt,
  FaUser,
} from "react-icons/fa";

const EntriesFilter = ({
  users = [],
  selectedUser,
  setSelectedUser,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  const hasInvalidDateRange =
    startDate &&
    endDate &&
    new Date(startDate) > new Date(endDate);

  return (
    <div className="entries-filter">
      <div className="filter-field">
        <label htmlFor="filter-user">
          <FaUser />
          Hausmeister
        </label>

        <select
          id="filter-user"
          value={selectedUser}
          onChange={(event) => setSelectedUser(event.target.value)}
        >
          <option value="">Alle Benutzer</option>

          {users.map((user) => (
            <option
              key={user.id || user.email}
              value={user.email}
            >
              {user.email} · {formatRole(user.role)}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-date-grid">
        <div className="filter-field">
          <label htmlFor="filter-start-date">
            <FaCalendarAlt />
            Von
          </label>

          <input
            id="filter-start-date"
            type="date"
            value={startDate}
            max={endDate || undefined}
            onChange={(event) => setStartDate(event.target.value)}
          />
        </div>

        <div className="filter-field">
          <label htmlFor="filter-end-date">
            <FaCalendarAlt />
            Bis
          </label>

          <input
            id="filter-end-date"
            type="date"
            value={endDate}
            min={startDate || undefined}
            onChange={(event) => setEndDate(event.target.value)}
          />
        </div>
      </div>

      {hasInvalidDateRange && (
        <p className="filter-validation-error" role="alert">
          Das Enddatum darf nicht vor dem Startdatum liegen.
        </p>
      )}
    </div>
  );
};

const formatRole = (role) => {
  switch (role) {
    case "superadmin":
      return "Superadmin";
    case "admin":
      return "Admin";
    default:
      return "Benutzer";
  }
};

export default EntriesFilter;